export interface ISocialAuthNeedsEmailResponse {
  next: "needs_email";
  linking_token: string;
  prefill_email: string | null;
  /** Absent when there is no prefill. False means the address still needs a code. */
  prefill_email_verified?: boolean | null;
}

export function isSocialAuthNeedsEmailResponse(
  value: unknown,
): value is ISocialAuthNeedsEmailResponse {
  return (
    typeof value === "object"
    && value !== null
    && (value as ISocialAuthNeedsEmailResponse).next === "needs_email"
  );
}
